import React from "react";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Section from "./Section";
import { Link } from "./../util/router";

const collageTiles = [
  { src: "/fr-1.png", offsetClass: "md:translate-y-0" },
  { src: "/anime-2.png", offsetClass: "md:translate-y-8" },
  { src: "/boobs-3.png", offsetClass: "md:translate-y-4" },
  { src: "/anime-4.png", offsetClass: "md:-translate-y-4" },
  { src: "/fr-5.png", offsetClass: "md:translate-y-6" },
  { src: "/boobs-1.png", offsetClass: "md:translate-y-2" },
];

function HeroSection(props) {
  return (
    <Section
      bgColor={props.bgColor}
      size={props.size}
      bgImage={props.bgImage}
      bgImageOpacity={props.bgImageOpacity}
    >
      <div
        aria-hidden="true"
        style={{
          position: "absolute",
          inset: 0,
          background:
            "radial-gradient(55% 50% at 12% 8%, rgba(255,77,109,0.28), transparent 60%), radial-gradient(55% 55% at 92% 18%, rgba(124,77,255,0.32), transparent 60%), radial-gradient(70% 60% at 50% 115%, rgba(244,81,30,0.20), transparent 60%), linear-gradient(180deg, rgba(7,5,24,0.45) 0%, rgba(7,5,24,0.88) 100%)",
          pointerEvents: "none",
        }}
      />
      <Container>
        <Grid container alignItems="center" spacing={6}>
          <Grid item xs={12} md={6}>
            <Box textAlign={{ xs: "center", md: "left" }}>
              {props.title && (
                <Typography
                  variant="h1"
                  component="h1"
                  style={{
                    fontSize: "clamp(2.4rem, 5vw, 3.6rem)",
                    fontWeight: 900,
                    lineHeight: 1.05,
                    letterSpacing: "-0.02em",
                    backgroundImage:
                      "linear-gradient(95deg, #FF9A4D 0%, #FF4D6D 45%, #B14CFF 100%)",
                    WebkitBackgroundClip: "text",
                    backgroundClip: "text",
                    WebkitTextFillColor: "transparent",
                    color: "transparent",
                    marginBottom: "1rem",
                  }}
                >
                  {props.title}
                </Typography>
              )}
              {props.smallTitle && (
                <Typography
                  variant="h2"
                  component="h2"
                  style={{
                    fontSize: "clamp(1.1rem, 2.2vw, 1.4rem)",
                    fontWeight: 700,
                    lineHeight: 1.3,
                    color: "rgba(255,255,255,0.94)",
                    marginBottom: "1rem",
                    maxWidth: 560,
                  }}
                >
                  {props.smallTitle}
                </Typography>
              )}
              {props.subtitle && (
                <Typography
                  variant="subtitle1"
                  style={{
                    fontSize: "1.02rem",
                    lineHeight: 1.65,
                    color: "rgba(255,255,255,0.70)",
                    maxWidth: 560,
                    display: "inline-block",
                  }}
                >
                  {props.subtitle}
                </Typography>
              )}
              <Box
                mt={3}
                display="flex"
                justifyContent={{ xs: "center", md: "flex-start" }}
              >
                <Button
                  component={Link}
                  to={props.buttonPath}
                  variant="contained"
                  size="large"
                  color={props.buttonColor}
                  style={{
                    paddingLeft: 32,
                    paddingRight: 32,
                    paddingTop: 14,
                    paddingBottom: 14,
                    fontSize: 16,
                    fontWeight: 700,
                    borderRadius: 999,
                    boxShadow:
                      "0 10px 30px -10px rgba(244,81,30,0.55), 0 0 0 1px rgba(255,255,255,0.06)",
                  }}
                >
                  {props.buttonText}
                </Button>
              </Box>
            </Box>
          </Grid>

          <Grid item xs={12} md={6}>
            <div className="relative mx-auto w-full max-w-[520px] px-2 md:px-0">
              <div
                aria-hidden="true"
                className="absolute -inset-6 rounded-[32px] opacity-60 blur-3xl"
                style={{
                  background:
                    "radial-gradient(circle at 30% 30%, rgba(244,81,30,0.45), transparent 60%), radial-gradient(circle at 80% 70%, rgba(124,77,255,0.45), transparent 60%)",
                }}
              />
              <div className="relative grid grid-cols-3 gap-3 md:gap-4">
                {collageTiles.map((tile, i) => (
                  <div
                    key={i}
                    className={`group relative overflow-hidden rounded-2xl border border-white/10 bg-white/5 shadow-2xl transition duration-500 hover:scale-[1.03] hover:border-white/30 ${tile.offsetClass}`}
                    style={{ aspectRatio: "3 / 4" }}
                  >
                    <img
                      src={tile.src}
                      alt=""
                      loading={i < 3 ? "eager" : "lazy"}
                      className="h-full w-full object-cover transition duration-700 group-hover:scale-110"
                    />
                    <div
                      aria-hidden="true"
                      className="absolute inset-0 bg-gradient-to-t from-black/40 via-transparent to-transparent"
                    />
                  </div>
                ))}
              </div>
            </div>
          </Grid>
        </Grid>
      </Container>
    </Section>
  );
}

export default HeroSection;
